<template>
    <div>
        <div class="float-left">
            <label>Report:</label>
            <el-select
                v-model="selectedReportType"
                placeholder="select report type"
            >
                <el-option
                    v-for="reportType in reportTypes"
                    :key="reportType"
                    :value="reportType"
                ></el-option>
            </el-select>
            <label>Timeframe:</label>
            <el-select v-model="selectedReportOption" placeholder="">
                <el-option
                    v-for="reportOption in reportOptions"
                    :key="reportOption"
                    :value="reportOption"
                ></el-option>
            </el-select>
            <label>Year:</label>
            <el-select v-model="selectedYear">
                <el-option
                    v-for="year in yearOptions"
                    :key="year"
                    :value="year"
                >
                    {{ year }}
                </el-option>
            </el-select>
            <span v-if="selectedReportOption == 'daily'">
                <label>Month:</label>
                <el-select v-model="selectedMonth">
                    <el-option
                        v-for="month in monthOptions"
                        :key="month"
                        :value="month"
                    >
                        {{ month }}
                    </el-option>
                </el-select>
            </span>
            <div class="mt-10">
                <el-button @click="getReportData">Update</el-button>
            </div>
        </div>
        <div class="clearfix"></div>
        <LineChartGenerator
            :chart-options="chartOptions"
            :chart-data="chartData"
            :chart-id="chartId"
            :dataset-id-key="datasetIdKey"
            :plugins="plugins"
            :css-classes="cssClasses"
            :styles="styles"
            :width="width"
            :height="height"
        />
    </div>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";

import {
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    Title,
    Tooltip
} from "chart.js";

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
);

export default {
    name: "LineChart",
    components: {
        LineChartGenerator
    },
    props: {
        chartId: {
            type: String,
            default: "line-chart"
        },
        datasetIdKey: {
            type: String,
            default: "label"
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 400
        },
        cssClasses: {
            default: "",
            type: String
        },
        styles: {
            type: Object,
            default: () => {}
        },
        plugins: {
            type: Array,
            default: () => []
        }
        // chartData: {
        //     type: Object,
        //     default: () => ({
        //         labels: [],
        //         datasets: [
        //             {
        //                 label: "",
        //                 data: [],
        //                 backgroundColor: ""
        //             }
        //         ]
        //     })
        // },
    },
    data() {
        return {
            chartData: {
                labels: [],
                datasets: [
                    {
                        label: "",
                        data: [],
                        backgroundColor: ""
                    }
                ]
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                suggestedMin: 0
            },
            yearOptions: [],
            monthOptions: [],
            selectedYear: new Date().getFullYear(),
            selectedMonth: "",
            reportTypes: ["order", "calendar", "newsletter", "revenue"],
            selectedReportType: "order",
            reportOptions: ["monthly", "daily"],
            selectedReportOption: "monthly"
        };
    },
    mounted() {
        //this.getMonthlyOrderStats(this.selectedYear);
        this.getReportData();
        this.yearOptions = _.range(
            new Date().getFullYear(),
            new Date().getFullYear() - 5,
            -1
        );
        this.monthOptions = _.range(1, 12);
        this.selectedYear = new Date().getFullYear();
        // this.fetchData().then((data) => {
        //     this.chartData = data;
        // });
    },
    // async mounted() {
    //     // Call the fetchData function passed as a prop to get the chart data
    //     this.chartData = await this.fetchData();
    // }.
    methods: {
        getMonthlyOrderStats() {
            this.loading = true;
            axios
                .get(`/web-api/monthly-statistics`, {
                    params: {
                        year: this.selectedYear
                    }
                })
                .then((response) => {
                    //console.log(response.data);
                    this.chartData.labels = response.data.labels;

                    this.chartData.datasets = response.data.data.map((data) => {
                        return {
                            data: data.totals,
                            label: data.label,
                            borderColor: data.color
                        };
                    });
                    //console.log(this.chartData);
                })
                .catch((error) => {
                    this.$message.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getReportData() {
            this.loading = true;
            axios
                .get(`/web-api/report-data`, {
                    params: {
                        year: this.selectedYear,
                        month: this.selectedMonth,
                        reportType: this.selectedReportType,
                        reportOption: this.selectedReportOption
                    }
                })
                .then((response) => {
                    //console.log(response.data);
                    this.chartData.labels = response.data.labels;

                    this.chartData.datasets = response.data.data.map((data) => {
                        return {
                            data: data.totals,
                            label: data.label,
                            borderColor: data.color
                        };
                    });
                    //console.log(this.chartData);
                })
                .catch((error) => {
                    this.$message.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
    // watch: {
    //     data: {
    //         handler(newData) {
    //             this.chartData.datasets = newData.map((data) => {
    //                 return {
    //                     data: data.totals,
    //                     label: data.label,
    //                     borderColor: data.color
    //                 };
    //             });
    //         },
    //         immediate: true
    //     },
    //     options: {
    //         handler(newOptions) {
    //             this.chartOptions = { ...this.chartOptions, ...newOptions };
    //         },
    //         immediate: true
    //     }
    // }
};
</script>
